import { useState } from "react";

import LoginMobile from "./LoginMobile";
import LoginEmail from "./LoginEmail";

const UserSignin = ({ t, Context, language }) => {
  const [isMobile, setIsMobile] = useState(false);

  return (
    <section>
      <div className="grid grid-cols-2 border-b sm:my-2">
        <button
          onClick={() => setIsMobile(!isMobile)}
          className={`w-full sm:w-44 text-xs sm:text-base sm:px-3 mx-auto text-secondary-800 p-1 sm:p-2 ${
            isMobile
              ? "font-bold border-b border-b-secondary-800"
              : "font-semibold"
          }`}
        >
          {t("Login with Mobile")}
        </button>
        <button
          onClick={() => setIsMobile(!isMobile)}
          className={`w-full sm:w-44 text-xs sm:text-base sm:px-3 mx-auto text-secondary-800 p-1 sm:p-2 ${
            !isMobile
              ? "font-bold border-b border-b-secondary-800"
              : "font-semibold"
          }`}
        >
          {t("Login with Email")}
        </button>
      </div>
      <p className="my-4 text-center max-sm:text-sm">
        <span className="font-bold text-secondary-800">
          {t("If you have an account")}
        </span>
        <span className="font-semibold text-zinc-500">
          {t(", Log in using your email.")}
        </span>
      </p>
      {isMobile ? (
        <LoginMobile {...{ t, Context }} />
      ) : (
        <LoginEmail {...{ t, Context, language }} />
      )}
    </section>
  );
};

export default UserSignin;
